import { render, staticRenderFns } from "./MixinDB.vue?vue&type=template&id=79b04ee0&scoped=true&lang=html&"
import script from "./MixinDB.vue?vue&type=script&lang=js&"
export * from "./MixinDB.vue?vue&type=script&lang=js&"
import style0 from "./MixinDB.vue?vue&type=style&index=0&id=79b04ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b04ee0",
  null
  
)

export default component.exports